/* ═══════════════════════════════════════════════════════════════
   Scroll reveals — the vanilla replacement for the React app's
   Reveal / Stagger / StaggerItem primitives.

   The whole thing hinges on one rule: content is never hidden by a
   stylesheet that a script has to come along and un-hide. Instead
   [data-gmd-reveal] on <html> gates every hidden state in the sheet,
   and layout/theme.liquid stamps it inline in the head — it has to
   land before first paint, which a deferred file cannot promise.

   So this file does not decide whether reveals happen. It reads that
   decision off the stamp and bails if it is absent, which covers both
   the reduced-motion case and any browser without an observer. There
   is no second, motionless version of the page to keep in sync: the
   unstamped page is the finished layout.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Set inline in <head>. Absent means reduced motion, or no observer,
  // or the stamp never ran — in every case, nothing to animate.
  if (!document.documentElement.hasAttribute('data-gmd-reveal')) return;

  /** Seconds between one staggered child and the next. Matches the
   *  React default (Stagger gap = 0.08). */
  var STAGGER_STEP = 0.08;

  var observer = null;

  function observerFor() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-gmd-in-view', '');
          observer.unobserve(entry.target);
        });
      },
      // A touch inside the viewport, so a band starts moving as it
      // arrives rather than after it has already been read.
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    return observer;
  }

  function stagger(container) {
    var i = 0;
    Array.prototype.forEach.call(container.children, function (child) {
      if (!child.hasAttribute('data-gmd-in')) return;
      // Written as a custom property so the delay lives in CSS with
      // the rest of the timing, not scattered across inline styles.
      child.style.setProperty('--gmd-i', String(i));
      i += 1;
    });
    container.style.setProperty('--gmd-step', STAGGER_STEP + 's');
  }

  function init(scope) {
    var where = scope || document;

    where.querySelectorAll('[data-gmd-stagger]').forEach(stagger);

    where.querySelectorAll('[data-gmd-in]').forEach(function (el) {
      if (el.hasAttribute('data-gmd-in-view')) return;
      observerFor().observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The theme editor swaps section markup in place. New nodes need
  // observing; the old ones went away with the node they were on.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
